import { useState } from "react";
import { getUno } from "../../api/apis";

export const useCambioInstalacion = () => {
  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [instalaciones, setInstalaciones] = useState([]);

  const getUnidadesNegocio = async () => {
    const resp = await getUno('getcategoriasinstalaciones', null, null);
    if ([200].includes(resp.status)) {
      setUnidadesNegocio(resp.data.data);
    }
  }

  const getInstalaciones = async categoria => {
    setInstalaciones([]);
    const resp = await getUno('getinstalacionesporcategoria', { "categoria": categoria }, null);
    if ([200].includes(resp.status)) {
      setInstalaciones(resp.data.data.data);
    }
  }

  return {
    getUnidadesNegocio, unidadesNegocio,
    getInstalaciones, instalaciones
  }
}
